import React from 'react'

const Cross = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.46447 15.5355L15.5355 8.46446" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
        <path d="M8.46447 8.46447L15.5355 15.5355" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
)


export default Cross
